import styled from 'styled-components'

export const BlogView = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1150px) {
    flex-direction: column;
  }
`

export const HeaderWrapper = styled.div`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 100;
`

export const BlogContent = styled.div`
  width: 70%;
  max-width: 1250px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1150px) {
    width: 100%;
    padding: 0;
    box-sizing: border-box;
    margin-top: 38px;
  }
`

export const BlogPostContainer = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 1100px;

  @media (max-width: 1150px) {
    flex-direction: column;
  }
`

export const BlogPostContent = styled.div`
  flex: 2.5;

  & h1 {
    margin: 0;
    padding: 0;
    font-weight: 700;
    font-size: 40px;
    line-height: 49px;
    color: #000000;
    margin-bottom: 0px;
    margin-top: 8px;
  }

  @media (max-width: 1150px) {
    padding: 0 21px;

    & h1 {
      font-size: 24px;
      line-height: 32px;
      margin-top: 0;
      margin-bottom: 14px;
      text-align: center;
    }
  }
`

export const BlogPostSidebar = styled.div`
  flex: 1;
  margin-left: 60px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 1150px) {
    margin-left: 0;
    padding: 20px;
  }
`

export const BlogPostInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 1150px) {
    justify-content: center;
  }
`

export const BlogPostAuthor = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  & img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 13px;
  }

  @media (max-width: 1150px) {
    justify-content: center;

    & img {
      width: 36px;
      height: 36px;
    }
  }
`

export const BlogPostAutorName = styled.span`
  display: block;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.01em;
  color: #000000;
`

export const BlogPostMetadata = styled.span`
  display: block;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.01em;
  color: #828282;

  @media (max-width: 1150px) {
    font-size: 12px;
  }
`

export const BlogPostBody = styled.div`
  & a {
    color: #0082b9;
    text-decoration: underline;
  }

  & h2 {
    margin-top: 60px;
    margin-bottom: 30px;
    font-weight: 500;
  }

  & h3,
  & h4,
  & h5,
  & h6 {
    font-weight: 500;
  }

  & p,
  & span,
  & font {
    font-family: 'Helvetica Neue', 'Helvetica' !important;
    font-weight: 300 !important;
    font-size: 18px !important;
    line-height: 28px !important;
    color: #000000;
    margin-bottom: 24px;
  }

  & h3 p,
  & h3 span,
  & h3 font,
  & h4 p,
  & h4 span,
  & h4 font,
  & h5 p,
  & h5 span,
  & h5 font,
  & h2 p,
  & h2 span,
  & h2 font {
    font-family: inherit !important;
    font-weight: inherit !important;
    font-size: inherit !important;
    line-height: inherit !important;
    color: inherit;
    margin-bottom: inherit;
  }

  & img {
    width: 100%;
  }

  @media (max-width: 1150px) {
    margin-top: 0;

    & p {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.01em;
    }
  }
`

export const BlogPostInfoMobile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.01em;
  color: #7e7e7e;

  & img {
    width: 24px;
    height: 24px;
    margin-right: 10px;
    border-radius: 50%;
  }

  & span {
    margin-bottom: -4px;
    margin-right: 10px;
  }

  @media (max-width: 1150px) {
    & img {
      width: 30px;
      height: 30px;
      margin-right: 6px;
    }
  }
`

export const BlogPostCategory = styled.span`
  display: block;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  color: #8f989f;
  text-decoration: underline;
  cursor: pointer;

  @media (max-width: 1150px) {
    text-align: center;
    font-size: 12px;
    line-height: 22px;
  }
`

export const BlogPostInfoShare = styled.div`
  display: flex;
  flex-directuion: row;
  align-items: center;
  justify-content: flex-end;
  margin-left: 30px;

  @media (max-width: 1150px) {
    justify-content: center;
    margin-top: 20px;
    margin-left: 0;
  }
`

export const BlogPostShareButton = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  margin-left: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 30px;
    height: 30px;
  }

  &:hover {
    opacity: 0.8;
  }
`

export const BlogPostParagraph = styled.p`
  text-align: ${props => props.alignment || 'left'};

  & > * {
    font-family: 'Helvetica Neue', Arial;
  }

  * > a {
    color: #0082b9;
  }
`

export const CodeBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const FeatureLine = styled.a`
  display: block;
  width: 100%;
  padding: 13px;
  font-weight: 700;
  font-size: 17px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.01em;
  text-decoration-line: underline;
  background: ${props => props.bgColor || '#FFCCA8'};
  color: ${props => props.textColor || 'black'};
  box-sizing: border-box;

  @media (max-width: 800px) {
    font-size: 14px;
    padding-left: 10px;
    padding-right: 10px;
  }
`

export const ImageWithButtonContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const ImageCtaButton = styled.a`
  background: linear-gradient(270deg, #ff9d74 0%, #ff5e6d 37.4%, #ff4f7e 74.69%, #ff6d90 100%);
  border-radius: 37px;
  width: 210px;
  height: 44px;
  margin-top: -22px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff !important;
  text-decoration: none !important;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;

  &:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)), linear-gradient(270deg, #ff9d74 0%, #ff5e6d 37.4%, #ff4f7e 74.69%, #ff6d90 100%);
  }
`

export const PostSeparatorButton = styled.a`
  background: linear-gradient(270deg, #ff9d74 0%, #ff5e6d 37.4%, #ff4f7e 74.69%, #ff6d90 100%);
  border-radius: 37px;
  width: 180px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff !important;
  text-decoration: none !important;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  cursor: pointer;

  &:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)), linear-gradient(270deg, #ff9d74 0%, #ff5e6d 37.4%, #ff4f7e 74.69%, #ff6d90 100%);
  }
`

export const PostAdSeparator = styled.div`
  width: 100%;
  height: 140px;
  background: #fff6f7;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 40px;
  position: relative;

  & span {
    font-weight: bold !important;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0.01em;
    color: #000000;
    display: block;
    margin-bottom: 10px;
    text-align: center;
  }

  @media (max-width: 800px) {
    & span {
      font-size: 16px !important;
      line-height: 22px !important;
      padding-left: 50px;
      padding-right: 50px;
      box-sizing: border-box;
    }
  }
`

export const PostImageSofa = styled.img`
  position: absolute;
  top: -10%;
  left: -1%;
  width: 120px !important;
  height: auto !important;

  @media (max-width: 800px) {
    width: 80px !important;
    top: -15%;
    left: -5%;
  }
`

export const PostImagePot = styled.img`
  position: absolute;
  bottom: -5%;
  right: -2%;
  width: 152px !important;
  height: auto !important;

  @media (max-width: 800px) {
    width: 100px !important;
    bottom: -10%;
    right: -5%;
  }
`

export const SingleDesignBlock = styled.div`
  width: 300px;
  margin-top: 91px;
`

export const SignleDesignBlogTitle = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.01em;
  color: #000000;
  margin-bottom: 15px;
`

export const SinglePostButton = styled.a`
  border: 2px solid #ff5e6d;
  border-radius: 33px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: none;
  color: #ff5e6d;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  width: 148px;
  height: 44px;
  margin: 16px auto 0;

  &:hover {
    background: #ff5e6d;
    color: white;
  }
`

export const PostShadow = styled.div`
  filter: drop-shadow(0px 1px 6px rgba(0, 0, 0, 0.1));
`

export const ListBlock = styled.ul`
  font-size 18px;
  font-weight 300;
  line-height 28px;
  list-style-type: none;
  li:not(:last-child) {
    margin-bottom: 12px;
  }
`

export const FloatingPanel = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100px;
  background: linear-gradient(270deg, #ff9d74 0%, #ff5e6d 37.4%, #ff4f7e 74.69%, #ff6d90 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 68px;
  padding: 14px 16px;
  box-sizing: border-box;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: 0px -6px 10px rgba(0, 0, 0, 0.1);

  @media (min-width: 800px) {
    display: none;
  }
`

export const FloatingPanelButton = styled.a`
  border-radius: 20px;
  background: #ffffff;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  text-decoration: none;
  padding: 8px 10px;
  display: flex;
  color: #ff5e6d;
  font-size: 12px;
`

export const FloatingPanelCloseButton = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 10px;
  height: 10px;
  width: 10px;
`

export const BlogPostHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 30px;

  & h1 {
    font-size: 48px;
    font-weight: 500;
    color: #000000;
    max-width: 1100px;
    margin: 0;
    margin-top: 16px;
    margin-bottom: 16px;
  }

  @media (max-width: 1150px) {
    & h1 {
      font-size: 28px;
      line-height: 32px;
      padding: 0 12px;
    }
  }
`

export const BlogPostCaption = styled.div`
  color: #6b6b6b;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-top: 8px;
  text-align: left;
  align-self: flex-start;
`

export const BlogPostSubtitle = styled.div`
  color: black;
  font-size: 24px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 16px;
  text-align: center;

  @media (max-width: 1150px) {
    font-size: 16px;
    line-height: 24px;
    padding: 0 12px;
  }
`
